/* Common Imports */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";

/* Component Imports */

import { Paper, Typography } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";

/* Data Imports */

import AppConfig from "../../../AppConfig";

/* Define all styles */

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "1.5rem",
    marginBottom: "2rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "100%",
  },
  heading: {
    color: "#202020",
    fontWeight: "400",
    fontSize: "1.5rem",
    lineHeight: "2.25rem",
    marginBottom: "1rem",
  },
  aboutBuilderDiv: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },
  contentDiv: {
    [theme.breakpoints.down("xs")]: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },
  },
  logo: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    margin: "1rem 1rem 1rem 0rem",
    height: "8rem !important",
    width: "8rem !important",
    borderRadius: "4px",
    boxShadow:
      "0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)",
  },
  logoImg: {
    height: "auto",
    width: "8rem !important",
    borderRadius: "4px",
  },
  projects: {
    marginRight: "1rem",
    color: "#202020",
    fontWeight: "400",
    fontSize: "1.125rem",
    lineHeight: "1.75rem",
    [theme.breakpoints.down("xs")]: {
      fontSize: "1rem",
      lineHeight: "1.25rem",
      marginRight: "0rem",
    },
  },
  est: {
    color: "#202020",
    fontWeight: "400",
    fontSize: "1.125rem",
    lineHeight: "1.75rem",
    [theme.breakpoints.down("xs")]: {
      fontSize: "1rem",
      lineHeight: "1.25rem",
      marginBottom: "0.625rem",
      marginTop: "0.625rem",
    },
  },
  desc: {
    width: "auto",
    color: "#666666",
    fontWeight: "400",
    fontSize: "1rem",
    lineHeight: "1.5rem",
    letterSpacing: "0.009rem",
  },
  builderSkeleton: {
    marginRight: "1rem",
    height: "8rem",
    "&.MuiSkeleton-text": {
      transform: "none",
    },
  },
}));

const AboutBuilder = (props) => {
  const classes = useStyles();

  if (!props.loading) {
    return (
      <React.Fragment>
        <Paper id="builder" elevation={2} className={classes.paper}>
          <Typography variant="body2" component="p" className={classes.heading}>
            About {props.builderName}
          </Typography>
          <div className={classes.aboutBuilderDiv}>
            <div className={classes.logo}>
              <img
                src={
                  props.builderLogo
                    ? props.builderLogo
                    : "/images/illustrations/common/ImageNotFound.svg"
                }
                alt={AppConfig.imageAltText}
                width={512}
                height={512}
                loading="lazy"
                referrerPolicy="no-referrer"
                className={classes.logoImg}
              />
            </div>
            <div className={classes.contentDiv}>
              <span className={classes.projects}>
                Total Projects:{" "}
                {props.builderProjects ? props.builderProjects : "-"}
              </span>
              <span className={classes.est}>
                Year Established: {props.builderEst ? props.builderEst : "-"}
              </span>
              <Typography
                variant="body2"
                component="p"
                className={classes.desc}
              >
                {props.builderDescription
                  ? props.builderDescription
                  : "Couldn't fetch data :("}
              </Typography>
            </div>
          </div>
        </Paper>
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <Paper elevation={2} className={classes.paper}>
          <Skeleton>
            <Typography
              variant="body2"
              component="p"
              className={classes.heading}
            >
              About {props.builderName}
            </Typography>
          </Skeleton>
          <div className={classes.aboutBuilderDiv}>
            <Skeleton className={classes.builderSkeleton}>
              <div className={classes.logo}>
                <img
                  src={
                    props.builderLogo
                      ? props.builderLogo
                      : "/images/illustrations/common/ImageNotFound.svg"
                  }
                  alt={AppConfig.imageAltText}
                  width={512}
                  height={512}
                  loading="lazy"
                  referrerPolicy="no-referrer"
                  className={classes.logoImg}
                />
              </div>
            </Skeleton>
            <div className={classes.contentDiv}>
              <Skeleton>
                <span className={classes.projects}>
                  Total Projects:{" "}
                  {props.builderProjects ? props.builderProjects : "-"}
                </span>

                <span className={classes.est}>
                  Year Established: {props.builderEst ? props.builderEst : "-"}
                </span>
              </Skeleton>
              <Skeleton width="100%">
                <Typography
                  variant="body2"
                  component="p"
                  className={classes.desc}
                >
                  {props.builderDescription
                    ? props.builderDescription
                    : "Couldn't fetch data :("}
                </Typography>
              </Skeleton>
            </div>
          </div>
        </Paper>
      </React.Fragment>
    );
  }
};

export default AboutBuilder;
